import { AmplitudeSink as e } from "./AmplitudeSink.mjs";
import { EventSchemas as t } from "../registry/EventSchemas.mjs";
import { logger as n } from "./logger.mjs";
import { EventQueue as r, QUEUE_KEY_PREFIX as i } from "./EventQueue.mjs";
import { FlushScheduler as a } from "./FlushScheduler.mjs";
import { uuid as o } from "./ids.mjs";
//#region src/core/DataLayer.ts
var s = 864e5, c = new class {
	constructor() {
		this.initialized = !1, this.starting = !1, this.generation = 0, this.config = null, this.queue = null, this.scheduler = null, this.tabId = "", this.sessionId = 0, this.currentProfile = {
			userId: null,
			email: null,
			userType: null
		}, this.preInitBuffer = [];
	}
	init(t) {
		if (this.starting || this.initialized) {
			n.warn("init() called more than once — ignoring. Only the shell should init.");
			return;
		}
		this.starting = !0;
		let i = ++this.generation;
		this.config = t, n.setVerbose(!!t.debug), this.tabId = t.tabId ?? this.generateTabId(), this.sessionId = this.generateSessionId();
		let o = t.eventTTL ?? s, c = t.maxStoredEvents ?? 1e3;
		this.queue = new r(this.tabId, t.adapter, o, c);
		let l = new e(t.amplitudeApiKey);
		this.scheduler = new a(this.queue, l, {
			flushInterval: t.flushInterval,
			maxQueueSize: t.maxQueueSize,
			priority: t.priority,
			lifecycle: t.lifecycle
		}), this.bootstrap(i);
	}
	async bootstrap(e) {
		let t = this.queue, r = this.scheduler;
		if (!t || !r) return;
		try {
			await t.hydrate(), await t.reapOrphans(i);
		} catch (e) {
			n.error("bootstrap storage error", e);
		}
		if (e !== this.generation) return;
		this.initialized = !0, r.start();
		let a = this.preInitBuffer;
		this.preInitBuffer = [];
		for (let e of a) e();
	}
	track(e, t) {
		if (!this.initialized) {
			this.preInitBuffer.push(() => this.track(e, t));
			return;
		}
		let n = e;
		this.validatePayload(n, t);
		let r = {
			id: o(),
			name: n,
			payload: t,
			timestamp: Date.now(),
			context: this.buildContext()
		};
		this.enqueue(r);
	}
	identify(e) {
		this.currentProfile = e, n.debug("identify", e.userId ?? "(anonymous)");
	}
	reset() {
		this.scheduler && this.scheduler.flush(), this.currentProfile = {
			userId: null,
			email: null,
			userType: null
		}, this.sessionId = this.generateSessionId();
	}
	clear() {
		this.preInitBuffer = [], this.queue && this.queue.clear();
	}
	shutdown() {
		this.scheduler?.stop(), this.generation++, this.initialized = !1, this.starting = !1, this.config = null, this.queue = null, this.scheduler = null, this.tabId = "", this.sessionId = 0, this.currentProfile = {
			userId: null,
			email: null,
			userType: null
		}, this.preInitBuffer = [];
	}
	async enqueue(e) {
		if (!(!this.queue || !this.scheduler)) try {
			await this.queue.enqueue(e), this.scheduler.onEnqueue(e.name);
		} catch (e) {
			n.error("enqueue failed", e);
		}
	}
	buildContext() {
		let e = this.config;
		return {
			userId: this.currentProfile.userId,
			email: this.currentProfile.email,
			userType: this.currentProfile.userType,
			platform: e.platform,
			sessionId: this.sessionId,
			tabId: this.tabId,
			appVersion: e.appVersion
		};
	}
	validatePayload(e, r) {
		if (!this.config?.debug) return;
		let i = t[e];
		if (!i) {
			n.warn("no schema registered for event", e);
			return;
		}
		let a = i.safeParse(r);
		if (!a.success) throw n.error("invalid event payload", e, a.error.flatten()), Error(`[DataLayer] Invalid payload for ${e}`);
	}
	generateSessionId() {
		return Date.now();
	}
	generateTabId() {
		return o();
	}
	_resetForTests() {
		this.shutdown();
	}
}();
//#endregion
export { c as DataLayer };
